{
  "version": 1,
  "asset_id": "70af9da2-df03-42cb-bb7c-2906d2a8ccee",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/70af9da2-df03-42cb-bb7c-2906d2a8ccee/hiatal-type-4-v2-1536.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/70af9da2-df03-42cb-bb7c-2906d2a8ccee/hiatal-type-4-v2-1536.jpg",
  "original_filename": "hiatal-type-4-v2-1536.jpg",
  "size": 210699,
  "content_type": "image/jpeg",
  "created_at": "2026-09-24T19:31:04Z"
}
